import instance from "./dsdInstance";
import {API_URL} from "../config/api";

export default class LabSolutionsService {

    static publishItems = async () => {
        try {
            const res = await instance.post(API_URL.LAB_SOLUTIONS + '/publish?type=LAB_SOLUTIONS');
            return res.data.data.result;
        } catch (e) {
            console.error(e);
        }
    }
    static deleteItem = async id => {
        try {
            return  await instance.delete(API_URL.LAB_SOLUTIONS + '/' + id + '?type=LAB_SOLUTIONS');
        } catch (e) {
            console.error(e);
        }
    }
    static createItem = async params => {
        try {
            return  await instance.post(API_URL.LAB_SOLUTIONS+ '?type=LAB_SOLUTIONS', params);
        } catch (e) {
            console.error(e);
        }
    }
    static editItem = async params => {
        try {
            return  await instance.put(API_URL.LAB_SOLUTIONS + '?type=LAB_SOLUTIONS', params);
        } catch (e) {
            console.error(e);
        }
    }
    static getAllItems = async() => {
       try {
        const res =  await instance.get(API_URL.LAB_SOLUTIONS + '?type=LAB_SOLUTIONS');
        return res.data.data.result;
       } catch (e) {
           console.error(e);
       }
    }
}
